export function noscroll(bool) {
    if (bool) {
        document.addEventListener('touchmove', disableScroll, {
            passive: false
        });
        document.addEventListener('mousewheel', disableScroll, {
            passive: false
        });
    } else {
        document.removeEventListener('touchmove', disableScroll, {
            passive: false
        });
        document.removeEventListener('mousewheel', disableScroll, {
            passive: false
        });
    }
}

export function disableScroll(event) {
    event.preventDefault();
}